/* global URLSearchParams */

import type { ReportCitation } from "@/types";
import type { OfficeSelection } from "@/types/api";
import { CHAT_APP_URL } from "./constants";

/** Capture the answer's source when it arrives; a later selection must not retarget its links. */
export function withReportCitationLinks(citations: ReportCitation[], selection: OfficeSelection): ReportCitation[] {
  return citations.map((citation) => ({ ...citation, sourceUrl: reportCitationUrl(citation, selection) }));
}

function reportCitationUrl(citation: ReportCitation, selection: OfficeSelection): string | undefined {
  const { context, organizationId } = selection;
  if (
    !organizationId ||
    context.requestType !== "performance" ||
    !citation.reportId ||
    citation.reportId !== context.reportId
  ) {
    return undefined;
  }

  let path: string;
  if (citation.source === "firm-aum" && context.scope === "firm") {
    path = "/firm-aum";
  } else if (
    citation.source === "fund-performance" &&
    context.scope === "product" &&
    context.productId &&
    context.fundId
  ) {
    path = `/products/${encodeURIComponent(context.productId)}/performance/fund-reporting/${encodeURIComponent(context.fundId)}`;
  } else {
    return undefined;
  }

  const report = new URLSearchParams({ report: citation.reportId });
  // The web app's existing activation route handles a different/no active organization
  // before opening the report. In particular, Firm AUM has no product-scoped loader.
  const params = new URLSearchParams({ organizationId, returnTo: `${path}?${report}` });
  return `${CHAT_APP_URL.replace(/\/$/, "")}/activate-org?${params}`;
}
